import { CONFIG } from 'utils/config';
import { getReturnUrl } from 'helpers';

export const usePricingConfig = (): {
    authenticatedPricingPath: string;
    guestPricingPath: string;
} => {
    const authenticatedPricingPath = `${
        CONFIG.VITE_PRICING_URL
    }/samples?returnUrl=${getReturnUrl()}`;
    const guestPricingPath = `${CONFIG.VITE_GUEST_PRICING_URL}/samples-en`;

    return {
        authenticatedPricingPath,
        guestPricingPath,
    };
};
